var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 232.398 249"}},[_c('path',{attrs:{"id":"Icon_material-title","data-name":"Icon material-title","d":"M-252.59-529.326v49.806h91.3v199.194h49.806V-479.52h91.289v-49.806Z","transform":"translate(252.59 529.326)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }